import { Color, Graph, Shape } from "@antv/x6";
import registerPowerMeterNode from "./registerPowerMeterNode";

export default function registerNode() {
  const baseURL = window.location.origin;
  const ports = {
    groups: {
      top: {
        position: "top",
        attrs: {
          circle: {
            r: 4,
            magnet: true,
            stroke: "#5F95FF",
            strokeWidth: 1,
            fill: "#fff",
            style: {
              visibility: "hidden",
            },
          },
        },
      },
      right: {
        position: "right",
        attrs: {
          circle: {
            r: 4,
            magnet: true,
            stroke: "#5F95FF",
            strokeWidth: 1,
            fill: "#fff",
            style: {
              visibility: "hidden",
            },
          },
        },
      },
      bottom: {
        position: "bottom",
        attrs: {
          circle: {
            r: 4,
            magnet: true,
            stroke: "#5F95FF",
            strokeWidth: 1,
            fill: "#fff",
            style: {
              visibility: "hidden",
            },
          },
        },
      },
      left: {
        position: "left",
        attrs: {
          circle: {
            r: 4,
            magnet: true,
            stroke: "#5F95FF",
            strokeWidth: 1,
            fill: "#fff",
            style: {
              visibility: "hidden",
            },
          },
        },
      },
      absolute: {
        position: { name: "absolute" },
        attrs: {
          circle: {
            r: 4,
            magnet: true,
            stroke: "#5F95FF",
            strokeWidth: 1,
            fill: "#fff",
            style: {
              visibility: "hidden",
            },
          },
        },
      },
    },
    items: [
      {
        id: "top",
        group: "top",
      },
      {
        id: "right",
        group: "right",
      },
      {
        id: "bottom",
        group: "bottom",
      },
      {
        id: "left",
        group: "left",
      },
    ],
  };

  //Text Box
  Graph.registerNode(
    "text-box",
    {
      inherit: "rect",
      width: 30,
      height: 30,
      attrs: {
        label: {
          fill: "var(--ant-color-text-base)",
          refX: 0.5,
          refY: 0.5,
          fontSize: 12,
          textAnchor: "middle",
          textVerticalAnchor: "middle",
          text: "Text",
        },
        body: {
          stroke: "transparent",
          fill: "transparent",
        },
      },
      ports: { ...ports },
    },

    true
  );

  //Power Grid
  Graph.registerNode(
    "power-grid",
    {
      width: 50,
      height: 50,
      markup: [
        { tagName: "rect", selector: "body" },
        { tagName: "image", selector: "image" },
        { tagName: "text", selector: "label" },
        { tagName: "text", selector: "active-power" },
        {
          tagName: "circle",
          selector: "indicator",
        },
      ],
      attrs: {
        body: {
          width: 60,
          height: 60,
          stroke: "",
          strokeWidth: 0,
          fill: "#ffffff00",
        },
        image: {
          refWidth: "110%",
          refHeight: "110%",
          refY: "-5%",
          refX: "-5%",
          fill: "#fff",
          "xlink:href": `${baseURL}/power-grid.png`,
        },
        label: {
          text: "Simple",
          refX: 0.5,
          refY: 0,
          refY2: -2,
          textAnchor: "middle",
          textVerticalAnchor: "bottom",
          fontWeight: 600,
          fontSize: 14,
          fill: "var(--ant-color-text-base)",
        },
        "active-power": {
          text: "- kW",
          refX: 0.5,
          refY: "100%",
          refY2: 10,
          textAnchor: "middle",
          textVerticalAnchor: "top",
          fontWeight: 600,
          fontSize: 14,
          fill: "var(--ant-color-text-base)",
        },
        indicator: {
          r: 6,
          refX: 0,
          refY: 0,
          refX2: -10,
          refY2: 10,
          fill: "var(--ant-color-success-text)",
          stroke: "grey",
          strokeWidth: 2,
        },
      },
      ports: { ...ports },
    },
    true
  );

  //Building
  Graph.registerNode(
    "building",
    {
      width: 80,
      height: 80,
      markup: [
        { tagName: "rect", selector: "body" },
        { tagName: "image", selector: "image" },
        { tagName: "text", selector: "label" },
        { tagName: "text", selector: "active-power" },
      ],
      attrs: {
        body: {
          width: 80,
          height: 80,
          refX: 0,
          refY: 0,
          stroke: "",
          strokeWidth: 0,
          fill: "#ffffff00",
        },
        image: {
          refWidth: "100%",
          refHeight: "100%",
          refY: 0,
          refX: 0,
          fill: "#fff",
          "xlink:href": `${baseURL}/factory.png`,
        },
        label: {
          text: "Factory",
          refX: 0.5,
          refY: 0,
          refY2: -5,
          textAnchor: "middle",
          textVerticalAnchor: "bottom",
          fontWeight: 600,
          fontSize: 14,
          fill: "var(--ant-color-text-base)",
        },
        "active-power": {
          text: "- kW",
          refX: 0.5,
          refY: "100%",
          refY2: 10,
          textAnchor: "middle",
          textVerticalAnchor: "top",
          fontWeight: 600,
          fontSize: 14,
          fill: "var(--ant-color-text-base)",
        },
      },
      ports: { ...ports },
    },
    true
  );

  //pv-panel
  Graph.registerNode(
    "pv-panel",
    {
      width: 50,
      height: 50,
      markup: [
        { tagName: "rect", selector: "body" },
        { tagName: "image", selector: "image" },
        { tagName: "text", selector: "label" },
        { tagName: "text", selector: "active-power" },
        {
          tagName: "circle",
          selector: "indicator",
        },
      ],
      attrs: {
        body: {
          width: 60,
          height: 60,
          stroke: "",
          strokeWidth: 0,
          fill: "#ffffff00",
        },
        image: {
          refWidth: "150%",
          refHeight: "150%",
          refY: "-50%",
          refX: "-50%",
          fill: "#fff",
          "xlink:href": `${baseURL}/solar-panel.png`,
        },
        label: {
          text: "Simple",
          refX: 0.5,
          refY: 0,
          refY2: -6,
          textAnchor: "middle",
          textVerticalAnchor: "bottom",
          fontWeight: 600,
          fontSize: 14,
          fill: "var(--ant-color-text-base)",
        },
        "active-power": {
          text: "- kW",
          refX: 0.5,
          refY: "100%",
          refY2: 2,
          textAnchor: "middle",
          textVerticalAnchor: "top",
          fontWeight: 600,
          fontSize: 14,
          fill: "var(--ant-color-text-base)",
        },
        indicator: {
          r: 6,
          refX: 0,
          refY: "100%",
          refX2: -10,
          refY2: -10,
          fill: "var(--ant-color-success-text)",
          stroke: "grey",
          strokeWidth: 2,
        },
      },
      ports: { ...ports },
    },
    true
  );

  //Power Meter Simple
  Graph.registerNode(
    "power-meter-simple",
    {
      width: 50,
      height: 50,
      markup: [
        { tagName: "rect", selector: "body" },
        { tagName: "image", selector: "image" },
        { tagName: "text", selector: "label" },
        { tagName: "text", selector: "active-power" },
        {
          tagName: "circle",
          selector: "indicator",
        },
      ],
      attrs: {
        body: {
          width: 60,
          height: 60,
          stroke: "",
          strokeWidth: 0,
          fill: "#ffffff00",
        },
        image: {
          refWidth: "110%",
          refHeight: "110%",
          refY: "-5%",
          refX: "-5%",
          fill: "#fff",
          "xlink:href": `${baseURL}/power-meter.png`,
        },
        label: {
          text: "Simple",
          refX: 0.5,
          refY: 0,
          refY2: -2,
          textAnchor: "middle",
          textVerticalAnchor: "bottom",
          fontWeight: 600,
          fontSize: 14,
          fill: "var(--ant-color-text-base)",
        },
        "active-power": {
          text: "- kW",
          refX: 0.5,
          refY: "100%",
          refY2: 3,
          textAnchor: "middle",
          textVerticalAnchor: "top",
          fontWeight: 600,
          fontSize: 14,
          fill: "var(--ant-color-text-base)",
        },
        indicator: {
          r: 6,
          refX: 0,
          refY: 0,
          refX2: -10,
          refY2: 10,
          fill: "var(--ant-color-success-text)",
          stroke: "grey",
          strokeWidth: 2,
        },
      },
      ports: { ...ports },
    },
    true
  );

  // //Power Meter Detailed
  // Graph.registerNode(
  //   "power-meter-detail",
  //   {
  //     width: 50,
  //     height: 50,
  //     markup: [
  //       {
  //         tagName: "g",
  //         selector: "table",
  //         children: [
  //           {
  //             tagName: "g",
  //             selector: "header",
  //             children: [
  //               {
  //                 tagName: "rect",
  //                 selector: "header-box",
  //                 attrs: { class: "box" },
  //               },
  //               {
  //                 tagName: "circle",
  //                 selector: "indicator",
  //               },
  //               {
  //                 tagName: "text",
  //                 selector: "label",
  //                 attrs: { class: "label" },
  //               },
  //             ],
  //           },
  //           {
  //             tagName: "g",
  //             selector: "volt-row",
  //             children: [
  //               {
  //                 tagName: "rect",
  //                 selector: "volt-box",
  //                 attrs: { class: "box" },
  //               },
  //               {
  //                 tagName: "text",
  //                 selector: "volt-label",
  //                 attrs: { class: "label" },
  //               },
  //               {
  //                 tagName: "rect",
  //                 selector: "volt-value-box",
  //                 attrs: { class: "value-box" },
  //               },
  //               {
  //                 tagName: "text",
  //                 selector: "volt-value",
  //                 attrs: { class: "value" },
  //               },
  //             ],
  //           },
  //           {
  //             tagName: "g",
  //             selector: "current-row",
  //             children: [
  //               {
  //                 tagName: "rect",
  //                 selector: "current-box",
  //                 attrs: { class: "box" },
  //               },
  //               {
  //                 tagName: "text",
  //                 selector: "current-label",
  //                 attrs: { class: "label" },
  //               },
  //               {
  //                 tagName: "rect",
  //                 selector: "current-value-box",
  //                 attrs: { class: "value-box" },
  //               },
  //               {
  //                 tagName: "text",
  //                 selector: "current-value",
  //                 attrs: { class: "value" },
  //               },
  //             ],
  //           },
  //           {
  //             tagName: "g",
  //             selector: "power-row",
  //             children: [
  //               {
  //                 tagName: "rect",
  //                 selector: "power-box",
  //                 attrs: { class: "box" },
  //               },
  //               {
  //                 tagName: "text",
  //                 selector: "power-label",
  //                 attrs: { class: "label" },
  //               },
  //               {
  //                 tagName: "rect",
  //                 selector: "power-value-box",
  //                 attrs: { class: "value-box" },
  //               },
  //               {
  //                 tagName: "text",
  //                 selector: "power-value",
  //                 attrs: { class: "value" },
  //               },
  //             ],
  //           },
  //         ],
  //       },
  //       { tagName: "image", selector: "image" },
  //       { tagName: "text", selector: "name" },
  //     ],
  //     attrs: {
  //       name: {
  //         text: "Detailed",
  //         refX: 0.5,
  //         refY: 0,
  //         refY2: -2,
  //         textAnchor: "middle",
  //         textVerticalAnchor: "bottom",
  //         fontWeight: 600,
  //         fontSize: 14,
  //         fill: "var(--ant-color-text-base)",
  //       },
  //       image: {
  //         refWidth: "110%",
  //         refHeight: "110%",
  //         refY: "-5%",
  //         refX: "-5%",
  //         fill: "#fff",
  //         "xlink:href": `${baseURL}/power-meter.png`,
  //       },
  //       table: { visibility: "hidden" },
  //       ".box": {
  //         width: 200,
  //         height: 25,
  //         refX: "100%",
  //         refX2: 20,
  //         stroke: "var(--ant-color-text-base)",
  //         strokeWidth: 1,
  //         fill: "#ffffff00",
  //       },
  //       ".value-box": {
  //         width: 0.1,
  //         height: 25,
  //         refX: "100%",
  //         refX2: 100,
  //         stroke: "var(--ant-color-text-base)",
  //         strokeWidth: 1,
  //         fill: "#ffffff00",
  //       },
  //       "header-box": { refY: "50%", refY2: -50 },
  //       "volt-box": { refY: "50%", refY2: -25 },
  //       "current-box": { refY: "50%" },
  //       "power-box": { refY: "50%", refY2: 25 },
  //       "volt-value-box": { refY: "50%", refY2: -25 },
  //       "current-value-box": { refY: "50%" },
  //       "power-value-box": { refY: "50%", refY2: 25 },
  //       indicator: {
  //         r: 6,
  //         refX: "100%",
  //         refX2: 33,
  //         refY: "50%",
  //         refY2: -38,
  //         fill: "var(--ant-color-success-text)",
  //         stroke: "grey",
  //         strokeWidth: 2,
  //       },
  //       ".label": {
  //         width: 20,
  //         fill: "var(--ant-color-text-base)",
  //         textAnchor: "middle",
  //         overflow: "hidden",
  //         textOverflow: "ellipsis",
  //         textVerticalAnchor: "middle",
  //         fontWeight: 600,
  //         fontSize: 14,
  //       },
  //       ".value": {
  //         width: 120,
  //         fill: "var(--ant-color-text-base)",
  //         textAnchor: "middle",
  //         overflow: "hidden",
  //         textOverflow: "ellipsis",
  //         textVerticalAnchor: "middle",
  //         fontSize: 14,
  //       },
  //       label: {
  //         refX: "100%",
  //         refX2: 120,
  //         refY: "50%",
  //         refY2: -38,
  //         text: "DPM",
  //       },
  //       "volt-label": {
  //         width: 5,
  //         refX: "100%",
  //         refX2: 60,
  //         refY: "50%",
  //         refY2: -13,
  //         text: "Voltage",
  //       },
  //       "current-label": {
  //         width: 5,
  //         refX: "100%",
  //         refX2: 60,
  //         refY: "50%",
  //         refY2: 13,
  //         text: "Current",
  //       },
  //       "power-label": {
  //         width: 5,
  //         refX: "100%",
  //         refX2: 60,
  //         refY: "50%",
  //         refY2: 38,
  //         text: "Power",
  //       },
  //       "volt-value": {
  //         width: 5,
  //         refX: "100%",
  //         refX2: 160,
  //         refY: "50%",
  //         refY2: -13,
  //         text: "- V",
  //       },
  //       "current-value": {
  //         width: 5,
  //         refX: "100%",
  //         refX2: 160,
  //         refY: "50%",
  //         refY2: 13,
  //         text: "- A",
  //       },
  //       "power-value": {
  //         width: 5,
  //         refX: "100%",
  //         refX2: 160,
  //         refY: "50%",
  //         refY2: 38,
  //         text: "- kW",
  //       },
  //     },
  //     ports: { ...ports },
  //     data: { meterId: 1 },
  //   },
  //   true
  // );

  registerPowerMeterNode();

  //General Transformer

  Graph.registerNode(
    "transformer",
    {
      width: 80,
      height: 80,
      markup: [
        { tagName: "rect", selector: "line-1" },
        { tagName: "circle", selector: "c-1", attrs: { class: "circle" } },
        { tagName: "circle", selector: "c-2", attrs: { class: "circle" } },
        { tagName: "text", selector: "title" },
        { tagName: "text", selector: "subtitle" },
        { tagName: "rect", selector: "line-2" },
      ],
      attrs: {
        "line-1": {
          width: 0.1,
          strokeWidth: 2,
          refX: "50%",
          refHeight: "15%",
          fill: "var(--ant-color-text-base)",
          stroke: "var(--ant-color-text-base)",
        },
        ".circle": {
          fill: "#ffffff00",
          strokeWidth: 2,
          stroke: "var(--ant-color-text-base)",
          refR: "20%",
          refX: "50%",
        },
        "c-1": { refY: "35%" },
        "c-2": { refY: "65%" },
        "line-2": {
          width: 0.1,
          strokeWidth: 2,
          refX: "50%",
          refY: "85%",
          refHeight: "15%",
          fill: "var(--ant-color-text-base)",
          stroke: "var(--ant-color-text-base)",
        },
        title: {
          text: "Transformer",
          fontSize: 16,
          fontWeight: 600,
          textAnchor: "left",
          textVerticalAnchor: "bottom",
          fill: "var(--ant-color-text-base)",
          refX: "70%",
          refX2: 20,
          refY: "50%",
        },
        subtitle: {
          text: "General",
          fill: "var(--ant-color-text-base)",
          fontSize: 12,
          textAnchor: "left",
          textVerticalAnchor: "top",
          refX: "70%",
          refX2: 20,
          refY: "50%",
          refY2: 2,
        },
      },
      ports: {
        ...ports,
        items: [
          {
            group: "top",
          },
          {
            group: "bottom",
          },
        ],
      },
    },
    true
  );

  //Star-Delta Transformer
  Graph.registerNode(
    "star-delta-transformer",
    {
      width: 80,
      height: 80,
      markup: [
        { tagName: "rect", selector: "line-1" },
        { tagName: "circle", selector: "c-1", attrs: { class: "circle" } },
        { tagName: "circle", selector: "c-2", attrs: { class: "circle" } },
        { tagName: "text", selector: "star" },
        { tagName: "text", selector: "delta" },
        { tagName: "text", selector: "title" },
        { tagName: "text", selector: "subtitle" },
        { tagName: "rect", selector: "line-2" },
      ],
      attrs: {
        "line-1": {
          width: 0.1,
          strokeWidth: 2,
          refX: "50%",
          refHeight: "15%",
          fill: "var(--ant-color-text-base)",
          stroke: "var(--ant-color-text-base)",
        },
        ".circle": {
          fill: "#ffffff00",
          strokeWidth: 2,
          stroke: "var(--ant-color-text-base)",
          refR: "20%",
          refX: "50%",
        },
        "c-1": { refY: "35%" },
        "c-2": { refY: "65%" },
        star: {
          text: "Δ",
          stroke: "var(--ant-color-text-base)",
          strokeWidth: 2,
          fontSize: 12,
          fontWeight: 200,
          textAnchor: "middle",
          textVerticalAnchor: "middle",
          refX: "50%",
          refY: "65%",
        },
        delta: {
          text: "Y",
          stroke: "var(--ant-color-text-base)",
          strokeWidth: 2,
          fontSize: 12,
          fontWeight: 200,
          textAnchor: "middle",
          textVerticalAnchor: "middle",
          refX: "50%",
          refY: "35%",
        },
        "line-2": {
          width: 0.1,
          strokeWidth: 2,
          refX: "50%",
          refY: "85%",
          refHeight: "15%",
          fill: "var(--ant-color-text-base)",
          stroke: "var(--ant-color-text-base)",
        },
        title: {
          text: "Transformer",
          fontSize: 16,
          fontWeight: 600,
          textAnchor: "left",
          textVerticalAnchor: "bottom",
          fill: "var(--ant-color-text-base)",
          refX: "70%",
          refX2: 20,
          refY: "50%",
          zIndex: 100,
        },
        subtitle: {
          text: "Star - Delta",
          fill: "var(--ant-color-text-base)",
          fontSize: 12,
          textAnchor: "left",
          textVerticalAnchor: "top",
          refX: "70%",
          refX2: 20,
          refY: "50%",
          refY2: 2,
        },
      },
      ports: {
        ...ports,
        items: [
          {
            group: "top",
          },
          {
            group: "bottom",
          },
        ],
      },
    },
    true
  );

  Graph.registerNode(
    "delta-star-transformer",
    {
      width: 80,
      height: 80,
      markup: [
        { tagName: "rect", selector: "line-1" },
        { tagName: "circle", selector: "c-1", attrs: { class: "circle" } },
        { tagName: "circle", selector: "c-2", attrs: { class: "circle" } },
        { tagName: "text", selector: "star" },
        { tagName: "text", selector: "delta" },
        { tagName: "text", selector: "title" },
        { tagName: "text", selector: "subtitle" },
        { tagName: "rect", selector: "line-2" },
      ],
      attrs: {
        "line-1": {
          width: 0.1,
          strokeWidth: 2,
          refX: "50%",
          refHeight: "15%",
          fill: "var(--ant-color-text-base)",
          stroke: "var(--ant-color-text-base)",
        },
        ".circle": {
          fill: "#ffffff00",
          strokeWidth: 2,
          stroke: "var(--ant-color-text-base)",
          refR: "20%",
          refX: "50%",
        },
        "c-1": { refY: "35%" },
        "c-2": { refY: "65%" },
        star: {
          text: "Δ",
          stroke: "var(--ant-color-text-base)",
          strokeWidth: 2,
          fontSize: 12,
          fontWeight: 200,
          textAnchor: "middle",
          textVerticalAnchor: "middle",
          refX: "50%",
          refY: "35%",
        },
        delta: {
          text: "Y",
          stroke: "var(--ant-color-text-base)",
          strokeWidth: 2,
          fontSize: 12,
          fontWeight: 200,
          textAnchor: "middle",
          textVerticalAnchor: "middle",
          refX: "50%",
          refY: "68%",
        },
        "line-2": {
          width: 0.1,
          strokeWidth: 2,
          refX: "50%",
          refY: "85%",
          refHeight: "15%",
          fill: "var(--ant-color-text-base)",
          stroke: "var(--ant-color-text-base)",
        },
        title: {
          text: "Transformer",
          fontSize: 16,
          fontWeight: 600,
          textAnchor: "left",
          textVerticalAnchor: "bottom",
          fill: "var(--ant-color-text-base)",
          refX: "70%",
          refX2: 20,
          refY: "50%",
        },
        subtitle: {
          text: "Delta - Star",
          fill: "var(--ant-color-text-base)",
          fontSize: 12,
          textAnchor: "left",
          textVerticalAnchor: "top",
          refX: "70%",
          refX2: 20,
          refY: "50%",
          refY2: 2,
        },
      },
      ports: {
        ...ports,
        items: [
          {
            group: "top",
          },
          {
            group: "bottom",
          },
        ],
      },
    },
    true
  );

  Graph.registerNode(
    "delta-delta-transformer",
    {
      width: 80,
      height: 80,
      markup: [
        { tagName: "rect", selector: "line-1" },
        { tagName: "circle", selector: "c-1", attrs: { class: "circle" } },
        { tagName: "circle", selector: "c-2", attrs: { class: "circle" } },
        { tagName: "text", selector: "delta-1" },
        { tagName: "text", selector: "delta-2" },
        { tagName: "text", selector: "title" },
        { tagName: "text", selector: "subtitle" },
        { tagName: "rect", selector: "line-2" },
      ],
      attrs: {
        "line-1": {
          width: 0.1,
          strokeWidth: 2,
          refX: "50%",
          refHeight: "15%",
          fill: "var(--ant-color-text-base)",
          stroke: "var(--ant-color-text-base)",
        },
        ".circle": {
          fill: "#ffffff00",
          strokeWidth: 2,
          stroke: "var(--ant-color-text-base)",
          refR: "20%",
          refX: "50%",
        },
        "c-1": { refY: "35%" },
        "c-2": { refY: "65%" },
        "delta-1": {
          text: "Δ",
          stroke: "var(--ant-color-text-base)",
          strokeWidth: 2,
          fontSize: 12,
          fontWeight: 200,
          textAnchor: "middle",
          textVerticalAnchor: "middle",
          refX: "50%",
          refY: "65%",
        },
        "delta-2": {
          text: "Δ",
          stroke: "var(--ant-color-text-base)",
          strokeWidth: 2,
          fontSize: 12,
          fontWeight: 200,
          textAnchor: "middle",
          textVerticalAnchor: "middle",
          refX: "50%",
          refY: "35%",
        },
        "line-2": {
          width: 0.1,
          strokeWidth: 2,
          refX: "50%",
          refY: "85%",
          refHeight: "15%",
          fill: "var(--ant-color-text-base)",
          stroke: "var(--ant-color-text-base)",
        },
        title: {
          text: "Transformer",
          fontSize: 16,
          fontWeight: 600,
          textAnchor: "left",
          textVerticalAnchor: "bottom",
          fill: "var(--ant-color-text-base)",
          refX: "70%",
          refX2: 20,
          refY: "50%",
        },
        subtitle: {
          text: "Delta - Delta",
          fill: "var(--ant-color-text-base)",
          fontSize: 12,
          textAnchor: "left",
          textVerticalAnchor: "top",
          refX: "70%",
          refX2: 20,
          refY: "50%",
          refY2: 2,
        },
      },
      ports: {
        ...ports,
        items: [
          {
            group: "top",
          },
          {
            group: "bottom",
          },
        ],
      },
    },
    true
  );

  Graph.registerNode(
    "star-star-transformer",
    {
      width: 80,
      height: 80,
      markup: [
        { tagName: "rect", selector: "line-1" },
        { tagName: "circle", selector: "c-1", attrs: { class: "circle" } },
        { tagName: "circle", selector: "c-2", attrs: { class: "circle" } },
        { tagName: "text", selector: "star-1" },
        { tagName: "text", selector: "star-2" },
        { tagName: "text", selector: "title" },
        { tagName: "text", selector: "subtitle" },
        { tagName: "rect", selector: "line-2" },
      ],
      attrs: {
        "line-1": {
          width: 0.1,
          strokeWidth: 2,
          refX: "50%",
          refHeight: "15%",
          fill: "var(--ant-color-text-base)",
          stroke: "var(--ant-color-text-base)",
        },
        ".circle": {
          fill: "#ffffff00",
          strokeWidth: 2,
          stroke: "var(--ant-color-text-base)",
          refR: "20%",
          refX: "50%",
        },
        "c-1": { refY: "35%" },
        "c-2": { refY: "65%" },
        "star-1": {
          text: "Y",
          stroke: "var(--ant-color-text-base)",
          strokeWidth: 2,
          fontSize: 12,
          fontWeight: 200,
          textAnchor: "middle",
          textVerticalAnchor: "middle",
          refX: "50%",
          refY: "68%",
        },
        "star-2": {
          text: "Y",
          stroke: "var(--ant-color-text-base)",
          strokeWidth: 2,
          fontSize: 12,
          fontWeight: 200,
          textAnchor: "middle",
          textVerticalAnchor: "middle",
          refX: "50%",
          refY: "35%",
        },
        "line-2": {
          width: 0.1,
          strokeWidth: 2,
          refX: "50%",
          refY: "85%",
          refHeight: "15%",
          fill: "var(--ant-color-text-base)",
          stroke: "var(--ant-color-text-base)",
        },
        title: {
          text: "Transformer",
          fontSize: 16,
          fontWeight: 600,
          textAnchor: "left",
          textVerticalAnchor: "bottom",
          fill: "var(--ant-color-text-base)",
          refX: "70%",
          refX2: 20,
          refY: "50%",
        },
        subtitle: {
          text: "Star - Star",
          fill: "var(--ant-color-text-base)",
          fontSize: 12,
          textAnchor: "left",
          textVerticalAnchor: "top",
          refX: "70%",
          refX2: 20,
          refY: "50%",
          refY2: 2,
        },
      },
      ports: {
        ...ports,
        items: [
          {
            group: "top",
          },
          {
            group: "bottom",
          },
        ],
      },
    },
    true
  );

  Graph.registerNode(
    "automatic-transfer-switch",
    {
      width: 80,
      height: 60,
      markup: [
        { tagName: "rect", selector: "rect" },
        { tagName: "circle", selector: "c-1", groupSelector: "circle" },
        { tagName: "circle", selector: "c-2", groupSelector: "circle" },
        { tagName: "circle", selector: "c-3", groupSelector: "circle" },
        { tagName: "rect", selector: "l-1", groupSelector: "line" },
        { tagName: "rect", selector: "l-2", groupSelector: "line" },
        { tagName: "rect", selector: "l-3", groupSelector: "line" },
        { tagName: "rect", selector: "switch", groupSelector: "line" },
        { tagName: "text", selector: "title" },
      ],
      attrs: {
        line: {
          stroke: "var(--ant-color-text-base)",
          fill: "#ffffff00",
          strokeWidth: 2,
        },
        "l-1": {
          height: 0.1,
          refWidth: "30.5%",
          refY: "40%",
        },
        "l-2": {
          height: 0.1,
          refWidth: "30.5%",
          refY: "40%",
          refX: "69.5%",
        },
        "l-3": {
          width: 0.1,
          refHeight: "35%",
          refY: "65%",
          refX: "50%",
        },
        circle: {
          stroke: "var(--ant-color-text-base)",
          fill: "#ffffff00",
          strokeWidth: 2,
        },
        "c-1": {
          refY: "62%",
          refX: "50%",
          refR: "3%",
        },
        "c-2": {
          refY: "40%",
          refX: "33%",
          refR: "3%",
        },
        "c-3": {
          refY: "40%",
          refX: "67%",
          refR: "3%",
        },
        title: {
          text: "ATS",
          fontSize: 16,
          fontWeight: 600,
          textAnchor: "left",
          textVerticalAnchor: "bottom",
          fill: "var(--ant-color-text-base)",
          refX: "100%",
          refX2: 10,
          refY: "30%",
        },
        rect: {
          refHeight: "75%",
          refWidth: "80%",
          refX: "10%",
          refY: "10%",
          stroke: "var(--ant-color-text-base)",
          fill: "#ffffff00",
          strokeWidth: 2,
        },
        switch: {
          width: 0.1,
          refHeight: "30%",
          refY: "59%",
          refY2: -1,
          refX: "50%",
          transform: `rotate(135)`,
        },
      },
      ports: {
        ...ports,
        items: [
          {
            group: "absolute",
            id: "in-1",
            args: {
              x: 0,
              y: "40%",
            },
          },
          {
            group: "absolute",
            id: "in-2",
            args: {
              x: "100%",
              y: "40%",
            },
          },
          {
            group: "bottom",
          },
        ],
      },
    },
    true
  );
}
